import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { SvgIconComponent } from "angular-svg-icon";

type CalloutType = "warn" | "info";
type CalloutStyle = "outlined" | "filled";

@Component({
  selector: "app-callout",
  templateUrl: "./callout.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./callout.component.scss"],
  imports: [SvgIconComponent]
})
export class CalloutComponent implements OnInit {
  @Input() type: CalloutType = "warn";
  @Input() style: CalloutStyle = "filled";

  public calloutClass: string = "callout";

  constructor() {}

  ngOnInit(): void {
    this.calloutClass += ` ${this.type}-${this.style}`;
  }
}
